var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocuments = function SvgDocuments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 43",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.317.176l-12.576 3.37 10.35 38.632 12.578-3.37L37.317.176z",
    fill: "#A07C97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.318.176l-6.29 1.685L41.38 40.493l6.289-1.685L37.318.176z",
    fill: "#780C5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.566 5.39l-6.702 1.796 4.293 16.02 6.702-1.795L35.566 5.39z",
    fill: "#FFC473"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.655 32.008a3.432 3.432 0 01-2.424 4.198 3.432 3.432 0 01-4.197-2.424 3.43 3.43 0 012.423-4.197 3.431 3.431 0 014.198 2.423z",
    fill: "#FF9800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.656 32.008a3.432 3.432 0 01-2.425 4.198l-1.774-6.62a3.431 3.431 0 014.199 2.422z",
    fill: "#FF623F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.566 5.39l-3.351.898 4.293 16.02 3.35-.897L35.567 5.39z",
    fill: "#FFAA20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H.979v40H14V2z",
    fill: "#83C9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H7.49v40H14V2z",
    fill: "#00A5FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.959 6.584H4.02v16.588h6.939V6.584z",
    fill: "#FFC473"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.917 34.134a3.432 3.432 0 01-3.428 3.428 3.432 3.432 0 01-3.427-3.428 3.431 3.431 0 013.427-3.428 3.431 3.431 0 013.428 3.428z",
    fill: "#FF9800"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.917 34.134a3.432 3.432 0 01-3.428 3.428v-6.856a3.431 3.431 0 013.428 3.428z",
    fill: "#FF623F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.959 6.584h-3.47v16.588h3.47V6.584z",
    fill: "#FFAA20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.021 2H14v40h13.021V2z",
    fill: "#6B77E8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.021 2h-6.51v40h6.51V2z",
    fill: "#4B5BE4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.98 6.584H17.04v16.588h6.939V6.584z",
    fill: "#FFC473"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.938 34.134a3.432 3.432 0 01-3.428 3.428 3.432 3.432 0 01-3.427-3.428 3.431 3.431 0 013.427-3.428 3.431 3.431 0 013.428 3.428z",
    fill: "#FF52A0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.938 34.134a3.432 3.432 0 01-3.428 3.428v-6.856a3.431 3.431 0 013.428 3.428z",
    fill: "#FF117D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.98 6.584h-3.47v16.588h3.47V6.584z",
    fill: "#FFAA20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.021 2H14v40h13.021V2z",
    fill: "#6B77E8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.02 2h-6.51v40h6.51V2z",
    fill: "#4B5BE4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.938 34.133a3.432 3.432 0 01-3.428 3.429v-6.856a3.431 3.431 0 013.428 3.427z",
    fill: "#FF117D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.98 6.584h-3.47v16.588h3.47V6.584z",
    fill: "#FFAA20"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/documents.1b4846c5.svg";
export { ForwardRef as ReactComponent };